"use client";

import { useMemo } from "react";
import { DEFAULT_BRIDGE_CONFIG, LIFI_WIDGET_THEME } from "./constants";
import { useBridgeEvents } from "./useBridgeEvents";
import { LiFiWidget, type WidgetConfig } from "@lifi/widget";

export interface LiFiBridgeWidgetProps {
  toChainId?: number;
  fromChainId?: number;
  toToken?: string;
  fromToken?: string;
  fromAmount?: string;
}

/**
 * LI.FI Bridge Widget with Cede Hub theming and Wagmi integration
 */
export function LiFiBridgeWidget({
  toChainId = DEFAULT_BRIDGE_CONFIG.toChain,
  fromChainId = DEFAULT_BRIDGE_CONFIG.fromChain,
  toToken: toTokenProp = DEFAULT_BRIDGE_CONFIG.toToken,
  fromToken: fromTokenProp = DEFAULT_BRIDGE_CONFIG.fromToken,
  fromAmount,
}: LiFiBridgeWidgetProps) {
  useBridgeEvents();

  const widgetConfig = useMemo((): Partial<WidgetConfig> => {
    return {
      appearance: "dark",
      theme: LIFI_WIDGET_THEME,
      variant: "compact",
      subvariant: "default",
      walletConfig: { usePartialWalletManagement: true },
      hiddenUI: ["poweredBy", "appearance", "language", "walletMenu"],
      toChain: toChainId,
      fromChain: fromChainId,
      toToken: toTokenProp,
      fromToken: fromTokenProp,
      fromAmount,
      buildUrl: false,
    };
  }, [toChainId, fromChainId, toTokenProp, fromTokenProp, fromAmount]);

  return <LiFiWidget integrator="cede-hub" config={widgetConfig} />;
}
